import React from "react";
import { ROUTES_CONFIG } from "src/constants/routesConfig";
import { Tooltip, PageLinkButton } from "..";

export const SendPurchaseOrderEmailSettingsToolTip: React.FC = () => {
  const message = (
    <div>
      <p>
        Email settings can be set in:&nbsp;
        <PageLinkButton path={ROUTES_CONFIG.updateUserSettings.path} text="Settings" />
      </p>
      <p>
        Vendors can be updated under <i>Management</i>.
      </p>
    </div>
  );

  return <Tooltip message={message} iconSize={16} />;
};

export const PurchaseOrderUploadTooltip: React.FC = () => {
  const message = (
    <div>
      <p>Purchase orders file must be exported from Prediko (Excel/XLSX file).</p>
      <p>
        &nbsp;&nbsp;&nbsp;<i>Integrated forecasting and PO creation is coming soon to HealfOps...</i>
      </p>
    </div>
  );

  return <Tooltip message={message} />;
};

export const ProductDiscrepancyTooltip: React.FC = () => {
  const message = (
    <>
      <p>
        This products discrepancies dynamically updates with each warehouse check-in. Please resolve the issue only
        after the full order has arrived, as partial shipments may automatically close it.
      </p>
      <p>Expiry dates are flagged as defective if the date is within 6 months.</p>
    </>
  );

  return <Tooltip message={message} iconSize={18} />;
};

export const FulfilmentRateTooltip: React.FC = () => {
  const message = <p>Fulfilment rate compares the ordered or confirmed quantity to the quantity received.</p>;

  return <Tooltip message={message} iconSize={18} />;
};
